import React from "react";
import { motion } from "framer-motion";
import { TrendingDown, Zap, Repeat, Handshake } from "lucide-react";

const POINTS = [
  { icon: TrendingDown, title: "Preços competitivos", desc: "Custos otimizados sem comprometer qualidade.", image: "/images/differentiators/competitive-pricing.webp", accent: "#00AEEF" },
  { icon: Zap, title: "Resposta rápida", desc: "Propostas comerciais em até 24 horas.", image: "/images/differentiators/quick-response.webp", accent: "#EC008C" },
  { icon: Repeat, title: "Fornecimento contínuo", desc: "Reposição atempada e gestão de stock.", image: "/images/differentiators/continuous-supply.webp", accent: "#FF7F00" },
  { icon: Handshake, title: "Parceiro de confiança", desc: "Proximidade e relações construídas a longo prazo.", image: "/images/differentiators/trusted-partner.webp", accent: "#0A1F44" },
];

export default function Differentiators() {
  return (
    <section className="relative py-24 lg:py-32 bg-muted/40" data-testid="differentiators-section">
      <div className="w-full px-5 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-semibold mb-4">
            Diferenciação
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground tracking-tight leading-[1.05]" data-testid="diff-title">
            Porque escolher a<br /> Ecoption Supply
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {POINTS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <motion.article
                key={p.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                className="group overflow-hidden rounded-2xl bg-card border border-border shadow-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:border-foreground/15"
                data-testid={`diff-tile-${idx}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt=""
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    loading="lazy"
                    decoding="async"
                    width="1200"
                    height="900"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/25 to-transparent" />
                  <div
                    className="absolute bottom-4 left-5 h-11 w-11 rounded-lg bg-white/95 shadow-md flex items-center justify-center"
                    style={{ color: p.accent }}
                  >
                    <Icon size={20} strokeWidth={2} />
                  </div>
                </div>
                <div className="p-6 lg:p-7">
                  <h3 className="font-display text-xl lg:text-2xl font-semibold text-foreground tracking-tight mb-2">{p.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
